import { render, staticRenderFns } from "./OverviewTableUserAccessManagementLine.vue?vue&type=template&id=2b06f36c&"
import script from "./OverviewTableUserAccessManagementLine.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableUserAccessManagementLine.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableUserAccessManagementLine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
